import { formatTime } from "../utils/timerUtils";

interface TimerDisplayProps {
  time: number;
}

export const TimerDisplay = ({ time }: TimerDisplayProps) => {
  return (
    <div className="relative text-center">
      <span className="text-5xl font-mono font-bold">{formatTime(time)}</span>
      <span className="block text-sm text-white/60 mt-2">Minutos</span>
    </div>
  );
};